/* global smily */

// This file requires the following components:
// - rentals-form

class RentalsFormCompact extends HTMLElement {
  constructor() {
    super();

    if (!this.content) return;

    this.placeHolder = this.content.innerHTML;

    this.labels = {
      destinations: '',
      dates: '',
      guests: '',
    };

    this.updateLabels();

    this.form.addEventListener('change', () => {
      this.updateLabels();
    });
  }

  updateLabels() {
    const { rentalsForm } = smily.website.t;
    const formInputs = [...this.form.formInputs];
    const dropdownInputs = formInputs.filter((input) => input.isDropdown);
    const { labels } = this;

    dropdownInputs.forEach((input) => {
      if (input.type === 'destinations' || input.type === 'destinations-remote') {
        const value = input.value?.split(',');
        if (!value) return;
        const { length } = value;
        const label = length > 1 ? smily.t(input.format, { count: length }) : value[0];
        labels.destinations = label || rentalsForm.destinations.placeholderAlt;
      } else if (input.type === 'dates') {
        labels.dates = input.value || rentalsForm.dates.placeholderAlt;
      } else if (input.type === 'increment') {
        labels.guests = input.value?.concat('+') || rentalsForm.guests.placeholderAlt;
      }
    });

    if (dropdownInputs.filter((input) => input.active).length === 0) {
      this.content.innerHTML = this.placeHolder;
    } else {
      this.content.innerHTML = `
        <div class="d-flex align-items-center">
          <div class="flex-grow-1">
            <div class="vstack small">
              <span class="d-inline-block text-truncate fw-bold" style="max-width: 150px;">
                ${labels.destinations.trim()}
              </span>
              <div class="d-flex gap-2 opacity-75">
                <div class="d-inline-flex icon-group gap-1">
                  <span>${labels.dates.trim()}</span>
                </div>
                <div class="d-inline-flex icon-group gap-1">
                  ${smily.svgIcon('guests', { w: 16, h: 16 })}
                  <span>${labels.guests.trim()}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      `;
    }
  }

  get form() {
    return (
      document.querySelector(this.getAttribute('data-target'))
      || this.closest('rentals-form')
    );
  }

  get content() {
    return this.querySelector('[data-content]');
  }
}

customElements.define('rentals-form-compact', RentalsFormCompact);
